import { render, staticRenderFns } from "./CollectionArrowRight.vue?vue&type=template&id=3c49662f"
import script from "./CollectionArrowRight.vue?vue&type=script&lang=js"
export * from "./CollectionArrowRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports